export default __webpack_public_path__ + "static/media/The Key Principal of Non-Refoulment - Dishani Shetty.967362e2.pdf";